import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Package, MessageCircle, X } from "lucide-react";
import api from "@/utils/api";
import { tr } from "@/utils/i18n";

const SUMMIT_WHATSAPP = "https://wa.me/17187173499?text=Hi%20Andre%2C%20I%27d%20like%20to%20reorder%20my%20peptides%20from%20Summit%20Peptides%20(PlanMyPeptides).";

export function ReorderReminderBanner({ getAuthHeader, language }) {
  const [reminders, setReminders] = useState([]);

  useEffect(() => {
    api.get("/reorder-reminders", { headers: getAuthHeader() })
      .then((res) => setReminders(res.data.reminders || []))
      .catch(() => setReminders([]));
  }, [getAuthHeader]);

  const dismiss = async (cycleId) => {
    setReminders((r) => r.filter((x) => x.cycle_id !== cycleId));
    try { await api.post(`/reorder-reminders/${cycleId}/dismiss`, {}, { headers: getAuthHeader() }); }
    catch { toast.error(tr(language, "Could not dismiss reminder", "Não foi possível dispensar", "No se pudo descartar")); }
  };

  if (!reminders.length) return null;
  return (
    <div className="space-y-3 mb-6" data-testid="reorder-reminders">
      {reminders.map((r) => (
        <div key={r.cycle_id} className="flex flex-col sm:flex-row sm:items-center gap-4 p-4 rounded-xl border border-amber-500/40 bg-amber-500/10"
          data-testid={`reorder-reminder-${r.cycle_id}`}>
          <Package className="w-6 h-6 text-amber-400 shrink-0" />
          <div className="flex-1">
            <p className="text-sm font-semibold text-amber-300">
              {tr(language, "Time to reorder", "Hora de reabastecer", "Hora de volver a pedir")} · {r.goal}
            </p>
            <p className="text-xs text-zinc-400 mt-1">
              {tr(language, "Your vials run out in about", "Seus frascos acabam em cerca de", "Tus viales se acaban en unos")} {r.days_left} {tr(language, "days", "dias", "días")} ({r.runout_date}).
              {r.peptides?.length ? ` ${r.peptides.join(", ")}` : ""}
            </p>
          </div>
          <a href={SUMMIT_WHATSAPP} target="_blank" rel="noopener noreferrer"
            className="px-4 py-2 rounded-lg font-semibold text-sm bg-green-600 hover:bg-green-500 text-white flex items-center gap-2 shrink-0"
            data-testid={`reorder-whatsapp-${r.cycle_id}`}>
            <MessageCircle className="w-4 h-4" />{tr(language, "Reorder from Summit", "Pedir na Summit", "Pedir a Summit")}
          </a>
          <button onClick={() => dismiss(r.cycle_id)} className="text-zinc-500 hover:text-white self-start sm:self-center"
            aria-label="Dismiss" data-testid={`reorder-dismiss-${r.cycle_id}`}>
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
